import React, { Component, PropTypes } from 'react';

/**
 * Class representing a general sub menu that can be used across the site. The intention for this menu is to select
 * an option that will be displayed within the module itself (i.e. not intended for external links).
 *
 * The general format for usage is:
 *   <ModuleSubMenu>
 *     <li>
 *       <a onClick={onClickFunction}>Link</a>
 *     </li>
 *     <li>
 *       <a onClick={onClickFunction}>Link</a>
 *     </li>
 *     ...
 *   </ModuleSubMenu>
 *
 * To style the text, target .ModuleSubMenu > li > a
 *
 * Use the onClick function to add the style 'is-active' to the li element you wish to have an underline. The
 * underline represents which option is currently selected.
 */

class ModuleSubMenu extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    isVerticalOnWideScreen: PropTypes.bool
  }

  _getClassName() {
    const { className, isVerticalOnWideScreen } = this.props;

    let totalClassName = "ModuleSubMenu";

    if (className) {
      totalClassName += " " + className;
    }
    if (isVerticalOnWideScreen) {
      totalClassName += " ModuleSubMenu--verticalAtWidth";
    }

    return totalClassName;
  }

  render() {
    const { children } = this.props;

    return (
      <ul className={this._getClassName.bind(this)()}>
        {children}
      </ul>
    );
  }
}

export default ModuleSubMenu;



// WEBPACK FOOTER //
// ./app/components/shared/ModuleSubMenu.js